import React, { useEffect, useRef, useState } from 'react';
import { useReveal } from '../hooks/UseReveal';

import Image from '../fragments/Image';
import SpecialText from '../fragments/SpecialText';

export default function Overview({ post }) {

	const headerRef = useReveal({ once: true });
	const metaRef = useReveal({ once: true });
	const textRef = useReveal({ once: true });
	const imageRef = useReveal({ once: true });

	if (!post) return null;

	const location = post.location?.[0]?.text || '';
	const category = post.category?.[0]?.text || '';
	const meta = post.meta || [];
	const overview = post.overview || '';


	return (
		<div id={'overview'} className="c-overview">
			<div className="c-overview__header c-transition-in" ref={headerRef}>
				<div className="l-grid">
					<div className="l-grid__col">
						{post.title && (
							<h1 className="c-overview__title">
								<SpecialText text={post.title} />
							</h1>
						)}
						<div className="c-overview__tags c-tags">
							{location && <span className="c-tags__tag">{location}</span>}
							{category && <span className="c-tags__tag">{category}</span>}
						</div>
					</div>
				</div>
			</div>
			<div className="c-overview__content">
				<div className="l-grid">
					<div className="l-grid__col l-grid__col--m-5-12 l-grid__col--l-4-12">
						{meta.length > 0 && (
							<div className="c-overview__meta c-transition-in" ref={metaRef}>
								{meta.map((item, index) => (
									<div className="c-overview__meta-item" key={index}>
										{item.heading && (
											<h3 className="c-overview__meta-heading">{item.heading}</h3>
										)}
										{item.text && (
											<p className="c-overview__meta-text">{item.text}</p>
										)}
									</div>
								))}
							</div>
						)}
					</div>
					<div className="l-grid__col l-grid__col--m-7-12 l-grid__col--l-8-12">
						{post.hero_img_src && (
							<div className="c-overview__image-wrapper l-bottom-section-space c-transition-in" ref={imageRef}>
								<Image
									src={post.hero_img_src}
									alt={post.hero_img_alt || ''}
									width={post.hero_img_width || 600}
									height={post.hero_img_height || 400}
								/>
							</div>
						)}
						{overview && (
							<div 
								className="c-overview__text c-transition-in scope-text scope-text--two-columns" 
								ref={textRef}
								dangerouslySetInnerHTML={{ __html: overview }}
							/>
						)}
					</div>
				</div>
			</div>		
		</div>
	);
}